var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcColoredAttachment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 44,
    viewBox: "0 0 36 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895431 0.895431 0 2 0H25.2643C25.8467 0 26.4002 0.253889 26.7801 0.695329L35.5157 10.8449C35.828 11.2078 35.9998 11.6707 35.9998 12.1496V42C35.9998 43.1046 35.1044 44 33.9998 44H2C0.895428 44 0 43.1046 0 42V2Z",
    fill: "#0E5CF4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 2.2854L24 12C24 12.5523 24.4477 13 25 13L33.8634 13C34.2984 13 34.5259 12.4828 34.232 12.1621L24.8686 1.94754C24.5604 1.61139 24 1.8294 24 2.2854Z",
    fill: "#E9FCFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 18V29C22 31.2091 20.2091 33 18 33V33C15.7909 33 14 31.2091 14 29V19.6667C14 18.1939 15.1939 17 16.6667 17V17C18.1394 17 19.3333 18.1939 19.3333 19.6667V28.6667C19.3333 29.403 18.7364 30 18 30V30C17.2636 30 16.6667 29.403 16.6667 28.6667V20",
    stroke: "#E9FCFF",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcColoredAttachment);
export default __webpack_public_path__ + "static/media/ic-colored-attachment.6856096890d96388308974cc14f13136.svg";
export { ForwardRef as ReactComponent };